import { PriceDisplay, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const DateSpan = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-soft);
  margin-right: 12px;
`;

export const StyledPriceDisplay = styled(PriceDisplay)`
  ${PriceDisplay.Styled.Price} {
    ${typographyV2.titleMd}
  }

  ${PriceDisplay.Styled.Currency} {
    ${typographyV2.bodyXXs};
  }
`;
